export default "__VITE_ASSET__37414371__"